export default {
  primary: '#2E3445',
  bg: '#2E3445',
  bgProfile: '#393E4E',
  bgSkills:'#424857',
  bgWork:'#4C515F',
  secondary: '#525E65',
  green:'#72C9A6',
  font:'#fff',
  fontYellow:'#FEFDF2'
}